const units = {
  toast: {
    error: {
      badResponse: '[Unit] resposta inválida do servidor',
      create: {},
      edit: {},
    },
    success: {
      create: { default: 'Local criado com sucesso' },
      edit: {},
      delete: {
        default: 'Os locais foram excluídos com sucesso',
      },
    },
  },
  headerButtons: {
    create: 'Criar',
    delete: {
      label: 'Remover',
      deleteModal: {
        header: 'Excluir Unidades',
        body: 'Você está prestes a excluir {{units}} unidades',
      },
    },
  },

  create: {
    errorToast: {
      message: 'Ocorreu um erro. Não foi possível criar o local',
    },
    duplicateToast: {
      message: 'O local com este nome já existe',
    },
    successToast: {
      message: 'sucesso! Local adicionado com sucesso',
    },
  },

  edit: {
    errorToast: {
      message: 'Ocorreu um erro. Não foi possível atualizar o local',
    },
    successToast: {
      message: 'sucesso! Local atualizado com sucesso',
    },
  },

  delete: {
    errorToast: {
      message: 'Ocorreu um erro. Não foi possível excluir o local',
    },
    successToast: {
      message: 'sucesso! Local excluído com sucesso',
    },
    deleteViewSite: {
      message: 'A visualização do local não pode ser excluída',
    },
  },

  form: {
    header: {
      create: {
        title: 'Criar',
      },

      update: {
        title: 'Atualizar',
      },
    },
    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },
    information: {
      details: {
        header: 'Detalhes',
        fields: {
          name: 'Nome',
        },
      },
      information: {
        header: 'Informação',
        fields: {
          operation: {
            title: 'Operação',
            options: {
              default: 'Default',
              school: 'School',
              NEMT: 'NEMT',
              microtransit: 'Microtransit',
              airportShuttle: 'Airport Shuttle',
              employee: 'Employee',
              deliveries: 'Deliveries',
              evs: 'EVs',
              broker: 'Broker',
            },
          },
          schoolOperationsEnabled: {
            title: 'Permitir escola',
          },
          employeeOperationsEnabled: {
            title: 'Permitir local de trabalho',
          },
        },
      },
      contactUsInformation: {
        header: 'Informações de Contato do Aplicativo Móvel',
        fields: {
          address: 'Endereço',
          phone: 'Telefone',
          email: 'E-mail',
        },
      },
    },
    valdations: {
      name: {
        required: 'Campo de nomeação obrigatória',
        name: 'Nome inválido',
      },
    },
  },
  table: {
    table: {
      headers: {
        name: 'name',
        operation: 'operation',
      },
    },
    actions: {
      delete: 'Remover',
      export: 'Exportar',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },
};

export default units;
